import React from "react";
import styles from "./CurrentAlarms.module.scss";
import WarningIcon from "@material-ui/icons/Warning";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { SensorWithAlarm } from "../../safetySensors/types";
import { useHistory } from "react-router-dom";
import { DeviceType } from "../../common/types";
import { useTranslation } from "react-i18next";
import { Box, Card, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
});
export interface ICurrentAlarm {
  currentAlarm: SensorWithAlarm;
}

export const Alarm = ({ currentAlarm }: ICurrentAlarm) => {
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();

  const navigateToAlarmDetails = () => {
    history.push(
      `/safetySensorDetails/${currentAlarm.NodeID}/${currentAlarm.MeasuringPointID}`
    );
  };

  return (
    <>
      <Card className={classes.root}>
        <Box
          onClick={() => navigateToAlarmDetails()}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            gridGap: 16,
          }}
        >
          <Typography variant="h2">
            {currentAlarm?.DeviceType === DeviceType.Leakage &&
              t("Leak detector")}
            {currentAlarm?.DeviceType === DeviceType.Smoke && t("Fire alarm")}
          </Typography>
          <Typography variant="h3">{currentAlarm.Address}</Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <WarningIcon
              fontSize="small"
              className={styles.warningIconActive}
            />
            <Typography variant="subtitle2">
              {currentAlarm?.Alert?.Description}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <ArrowForwardIosIcon className={styles.arrowIcon} fontSize="small" />
        </Box>
      </Card>
    </>
  );
};
